import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { LookupService } from './lookup.service';
import { LookupModel } from '@siren-survey/app/models/shared/lookup.model';

@Injectable({
  providedIn: 'root'
})
export class AnswerTypesResolver implements Resolve<LookupModel[]> {

  constructor(private _lookupService: LookupService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LookupModel[]> {
    return this._lookupService.getLookupsService(["AnswerType"]).pipe(
      map(result => {
        return result.body;
      })
    );
  }
}
